import Footer from 'Layout/MainLayout/Footer/Footer';
import Navbar from 'Layout/MainLayout/Header/Navbar';
import React, { Suspense, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from 'Views/Loader/Loader';

const Dashboard = React.lazy(() => import('Views/Dashboard/dashboard'));
const NotFoundPage = React.lazy(() => import('Views/NotFound/NotFound'));


function AppRoutes() {
   const [theme, setTheme] = useState('light');

   const toggleTheme = () => {
      setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
   };
   return (
      <div className={theme}>
         <Navbar toggleTheme={toggleTheme} />
         <Suspense
            fallback={
               <div>
                  <Loader />
               </div>
            }
         >
            <Routes>
               <Route path="/" element={<Dashboard />} />
               <Route path="*" element={<NotFoundPage />} />
            </Routes>
         </Suspense>
         <Footer />
      </div>
   );
}

export default AppRoutes;
